export default __webpack_public_path__ + "static/media/logo.c78c170f.png";